import AutosubmitControl from '@/js/Controls/AutosubmitControl'
import BottomStuck from '@/js/Controls/BottomStuck'
import CarouselControl from '@/js/Controls/CarouselControl'
import CheckboxGroupControl from '@/js/Controls/CheckboxGroupControl'
import CollapsableControl from '@/js/Controls/CollapsableControl'
import EqualHeightsControl from '@/js/Controls/EqualHeightsControl'
import FormFloatingControl from '@/js/Controls/FormFloatingControl'
import ScrollToActive from '@/js/Controls/ScrollToActive'
import TooltipControl from '@/js/Controls/TooltipControl'
import { ControlManager } from '@peckadesign/pd-naja'
import naja from 'naja'

// Controls have to be registered before `naja.initialize()` is called, `ControlManager` binds their initialization to
// the naja `init` event.
const controlManager = new ControlManager(naja)

controlManager.addControlOnLoad(AutosubmitControl)
controlManager.addControlOnLoad(ScrollToActive)

controlManager.addControlOnLive(BottomStuck)
controlManager.addControlOnLive(CarouselControl)
controlManager.addControlOnLive(CheckboxGroupControl)
controlManager.addControlOnLive(CollapsableControl)
controlManager.addControlOnLive(EqualHeightsControl)
controlManager.addControlOnLive(FormFloatingControl)
controlManager.addControlOnLive(TooltipControl)
